module.exports = __webpack_public_path__ + "img/align_top.a5a4b3fb.svg";